module.exports = __webpack_public_path__ + "img/img-product-btt-notification.197d92f9.svg";